<script>
import NewSend from "./Send/Index";
import List from "./List/List";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    NewSend,
    List
  },
  data() {
    return { sendNotificationComponentKey: 0, send: false };
  },
  methods: {
    ...mapActions("notifications", ["listAll"]),
    forceRerenderSendNotificationComponent() {
      this.sendNotificationComponentKey += 1;
    },
    closeSendDialog() {
      this.send = false;
      this.listAll();
    }
  }
};
</script>

<template>
  <v-container fluid grid-list-md class="box">
    <v-card-title class="d-flex align-end px-0" primary-title>
      <div class="d-flex align-center">
        <v-icon color="black" :size="30" class="mr-2">mdi-bell</v-icon>
        <h3 class="font-weight-regular text-uppercase">Notificações</h3>
        <v-btn
          small
          outlined
          rounded
          class="ml-3"
          color="secondary"
          @click="send = true"
          >criar notificação</v-btn
        >
      </div>

      <v-spacer></v-spacer>
    </v-card-title>

    <new-send :visible="send" @close="closeSendDialog()" />
    <br />
    <list />
  </v-container>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/Index.vue